export default __webpack_public_path__ + "static/media/Screenshot 2022-05-31 at 3.20.27 PM.689ea981.png";